import DowntimeBlockTooltip from "components/common/Scheduler/SchedulerRenderers/components/blocks/DowntimeBlockTooltip";
import WorkBlockTooltip from "components/common/Scheduler/SchedulerRenderers/components/blocks/WorkBlockTooltip";
import Block from "domain/Block";
import React from "react";

export default function blockTooltipRenderer({
  applicationContext,
  displaySnappedRemainingDuration,
  endDate,
  block,
  gapFiller,
  line,
  showStatus,
  startDate,
}) {
  switch (Block.type(block)) {
    case "DowntimeBlock":
      return (
        <DowntimeBlockTooltip downtimeBlock={block} endDate={endDate} line={line || block.line} startDate={startDate} />
      );
    case "WorkBlock":
      return (
        <WorkBlockTooltip
          applicationContext={applicationContext}
          displaySnappedRemainingDuration={displaySnappedRemainingDuration}
          endDate={endDate}
          gapFiller={gapFiller}
          line={line || block.line}
          showStatus={showStatus}
          startDate={startDate}
          workBlock={block}
        />
      );
    default:
      throw new Error(`ERROR: Unidentified block type: ${Block.type(block)}`);
  }
}
